/* =============================================
   STRIKER THREADS — Shopify Theme JS
   ============================================= */

/* ===== TOAST ===== */
function showToast(msg) {
  const t = document.getElementById('st-toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3000);
}

/* ===== MOBILE NAV ===== */
function openMobileNav() {
  document.getElementById('mobileNav').classList.add('open');
  document.getElementById('mobileOverlay').style.display = 'block';
  document.body.style.overflow = 'hidden';
}
function closeMobileNav() {
  document.getElementById('mobileNav').classList.remove('open');
  document.getElementById('mobileOverlay').style.display = 'none';
  document.body.style.overflow = '';
}

/* ===== CART COUNT ===== */
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const count = cart.item_count || 0;
      document.querySelectorAll('.st-cart-count').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    })
    .catch(() => {});
}

/* ===== AJAX ADD TO CART ===== */
function addToCartAjax(variantId, qty, productTitle, size) {
  if (!variantId) {
    showToast('Please select a size');
    return Promise.reject('no variant');
  }
  const btn = document.querySelector('.add-to-cart-main');
  if (btn) {
    btn.disabled = true;
    btn.innerHTML = '<span class="loading-spinner"></span> Adding...';
  }
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
    .then(r => r.json())
    .then(data => {
      updateCartCount();
      const sizeLabel = size ? ` (${size})` : '';
      showToast(`${productTitle || 'Item'}${sizeLabel} added to cart!`);
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
      return data;
    })
    .catch(err => {
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
      showToast('Could not add to cart. Please try again.');
      throw err;
    });
}

/* ===== PRODUCT PAGE — VARIANT SELECTION ===== */
function initProductPage() {
  const variantDataEl = document.getElementById('product-variants-json');
  if (!variantDataEl) return;

  let variants;
  try {
    variants = JSON.parse(variantDataEl.textContent);
  } catch (e) { return; }

  let selectedVariantId = null;

  function findVariantBySize(size) {
    return variants.find(v =>
      v.option1 === size || v.option2 === size || v.option3 === size
    );
  }

  function updateAddToCartBtn(variant) {
    const btn = document.querySelector('.add-to-cart-main');
    if (!btn) return;
    if (!variant) {
      btn.disabled = true;
      btn.textContent = 'Unavailable';
      return;
    }
    if (!variant.available) {
      btn.disabled = true;
      btn.textContent = 'Sold Out';
      return;
    }
    btn.disabled = false;
    btn.textContent = 'Add to Cart';
    selectedVariantId = variant.id;
  }

  // Size buttons
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const size = this.dataset.size;
      const variant = findVariantBySize(size);
      updateAddToCartBtn(variant);
    });
  });

  // Add to cart
  const addBtn = document.querySelector('.add-to-cart-main');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      const activeSize = document.querySelector('.size-btn.active');
      if (!activeSize) {
        showToast('Please select a size first');
        return;
      }
      const productTitle = document.querySelector('.product-detail-name')?.textContent || 'Jersey';
      addToCartAjax(selectedVariantId, 1, productTitle, activeSize.dataset.size);
    });
  }

  // Quick add buttons on cards
  document.querySelectorAll('.quick-add-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const vid = this.dataset.variantId;
      const title = this.dataset.title;
      if (vid) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
        })
          .then(r => r.json())
          .then(() => {
            updateCartCount();
            showToast(`${title || 'Item'} added to cart!`);
          })
          .catch(() => showToast('Could not add to cart.'));
      }
    });
  });

  // Gallery thumbnails
  document.querySelectorAll('.gallery-thumb').forEach((thumb, i) => {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const mainImg = document.querySelector('.gallery-main img');
      const src = this.dataset.src;
      if (mainImg && src) mainImg.src = src;
    });
  });

  // Product description accordions
  document.querySelectorAll('.product-desc-title').forEach(title => {
    title.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector('.desc-icon');
      if (!content) return;
      const isOpen = content.style.display !== 'none';
      content.style.display = isOpen ? 'none' : 'block';
      if (icon) icon.textContent = isOpen ? '+' : '−';
    });
  });
}

/* ===== COLLECTION PAGE FILTER ===== */
function initCollectionFilters() {
  const filterBtns = document.querySelectorAll('.filter-btn[data-filter]');
  if (!filterBtns.length) return;

  filterBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      filterBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const filter = this.dataset.filter;
      const cards = document.querySelectorAll('.product-card[data-tags]');
      cards.forEach(card => {
        if (filter === 'all') {
          card.style.display = '';
        } else {
          const tags = card.dataset.tags || '';
          card.style.display = tags.toLowerCase().includes(filter.toLowerCase()) ? '' : 'none';
        }
      });
      // update count
      const countEl = document.getElementById('collection-count');
      if (countEl) {
        const visible = document.querySelectorAll('.product-card[data-tags]:not([style*="none"])').length;
        countEl.textContent = `Showing ${visible} jerseys`;
      }
    });
  });
}

/* ===== CART PAGE ===== */
function initCartPage() {
  // Qty buttons
  document.querySelectorAll('.cart-qty-form').forEach(form => {
    form.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const input = form.querySelector('.qty-input');
        const key = form.dataset.key;
        const delta = parseInt(this.dataset.delta);
        let qty = parseInt(input.value) + delta;
        if (qty < 0) qty = 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(r => r.json())
          .then(() => { updateCartCount(); window.location.reload(); })
          .catch(() => showToast('Update failed.'));
      });
    });
  });

  // Remove buttons
  document.querySelectorAll('.remove-item-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(r => r.json())
        .then(() => { updateCartCount(); window.location.reload(); })
        .catch(() => showToast('Remove failed.'));
    });
  });
}

/* ===== SEARCH ===== */
function initSearch() {
  const input = document.getElementById('searchInput');
  if (!input) return;
  let debounceTimer;
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const q = this.value.trim();
      if (q.length > 1) {
        window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
      }
    }, 500);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      const q = this.value.trim();
      if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
    }
  });
}

/* ===== ACTIVE NAV LINK ===== */
function setActiveNav() {
  const path = window.location.pathname;
  document.querySelectorAll('.site-nav a, .mobile-nav a').forEach(a => {
    if (a.getAttribute('href') && path.startsWith(a.getAttribute('href')) && a.getAttribute('href') !== '/') {
      a.classList.add('active');
    }
  });
}

/* ===== INIT ===== */
document.addEventListener('DOMContentLoaded', function () {
  updateCartCount();
  initSearch();
  setActiveNav();
  initProductPage();
  initCollectionFilters();
  initCartPage();
});
/* ===== HEADER PREDICTIVE SEARCH ===== */
(function () {
  function initPredictiveSearch() {
    var wrap = document.querySelector('[data-predictive-search]');
    if (!wrap) return;
    var input = wrap.querySelector('#searchInput');
    var results = wrap.querySelector('.predictive-results');
    if (!input || !results) return;

    // Replace the legacy redirect-on-keystroke search
    var oldClone = input.cloneNode(true);
    input.parentNode.replaceChild(oldClone, input);
    input = oldClone;

    var debounceTimer;
    function format(amountCents) {
      try {
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: window.Shopify && Shopify.currency && Shopify.currency.active || 'INR', maximumFractionDigits: 0 }).format(amountCents / 100);
      } catch (e) {
        return '₹' + Math.round(amountCents / 100);
      }
    }

    function render(items, q) {
      results.innerHTML = '';
      if (!items.length) {
        results.innerHTML = '<div class="predictive-empty">No results for "' + (q || '').replace(/[<>]/g, '') + '"</div>';
        results.removeAttribute('hidden');
        return;
      }
      items.slice(0, 6).forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'predictive-item';
        a.href = p.url;
        var img = p.featured_image && (p.featured_image.url || p.featured_image);
        a.innerHTML = '' +
          '<div class="predictive-thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span style="font-size:24px">👕</span>') + '</div>' +
          '<div class="predictive-meta">' +
            '<div class="predictive-title">' + p.title + '</div>' +
            '<div class="predictive-price">' + (p.price ? format(p.price * 100) : '') + '</div>' +
          '</div>';
        results.appendChild(a);
      });
      var view = document.createElement('a');
      view.className = 'predictive-viewall';
      view.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      view.textContent = 'View all results';
      results.appendChild(view);
      results.removeAttribute('hidden');
    }

    function search(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () {
          results.setAttribute('hidden', '');
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = this.value.trim();
      if (q.length < 2) {
        results.setAttribute('hidden', '');
        return;
      }
      debounceTimer = setTimeout(function () { search(q); }, 220);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var q = this.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
      if (e.key === 'Escape') {
        results.setAttribute('hidden', '');
        this.blur();
      }
    });

    input.addEventListener('focus', function () {
      if (this.value.trim().length >= 2 && results.children.length) {
        results.removeAttribute('hidden');
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) results.setAttribute('hidden', '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPredictiveSearch);
  } else {
    initPredictiveSearch();
  }
})();

/* ===== PRODUCT PAGE ACCORDION (event delegation, defensive) ===== */
document.addEventListener('click', function (e) {
  var t = e.target.closest('.product-desc-title');
  if (!t) return;
  var content = t.nextElementSibling;
  if (!content || !content.classList.contains('product-desc-content')) return;
  var icon = t.querySelector('.desc-icon');
  var isOpen = content.style.display && content.style.display !== 'none';
  content.style.display = isOpen ? 'none' : 'block';
  if (icon) icon.textContent = isOpen ? '+' : '−';
});
